/**
 *  @class
 *  @function TabbedContent
 */
if (!customElements.get('tabbed-content')) {
	class TabbedContent extends HTMLElement {
		static get observedAttributes() {
	    return ['selected-index'];
	  }
	  constructor() {
			super();
	  }

		connectedCallback() {
			this.selectedIndex = this.selectedIndex;
			this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
			this.scroller = this.querySelector('.tabbed-content--scroll');
			this.buttons = Array.from(this.scroller.querySelectorAll('button[role="tab"]'));
			this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
			this.tl = false;
			if ( this.animations_enabled ) {
				this.tl = gsap.timeline({
					paused: true
				});
			}

			this.buttons.forEach((button, index) => {
				button.addEventListener('click', () => {
					this.selectedIndex = index;
				});
				button.addEventListener('keydown', (event) => {
					this.handleKeydown(event, index);
				});
			});
			if (Shopify.designMode) {
	      this.addEventListener('shopify:block:select', (event) => {
					this.selectedIndex = this.buttons.indexOf(event.target);
				});
	    }
		}
		handleKeydown(event, currentIndex) {
			let newIndex;
			switch (event.key) {
				case 'ArrowRight':
					newIndex = (currentIndex + 1) % this.buttons.length;
					break;
				case 'ArrowLeft':
					newIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
					break;
				case 'Home':
					newIndex = 0;
					break;
				case 'End':
					newIndex = this.buttons.length - 1;
					break;
				default:
					return;
			}
			event.preventDefault();
			this.selectedIndex = newIndex;
			this.buttons[newIndex].focus();
		}
		get selectedIndex() {
	    return parseInt(this.getAttribute('selected-index')) || 0;
	  }
	  set selectedIndex(index) {
	    this.setAttribute('selected-index', index);
	  }
		attributeChangedCallback(name, oldValue, newValue) {

	    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
				const oldIdx = parseInt(oldValue);
				const newIdx = parseInt(newValue);

				// Update ARIA states on tabs
				this.buttons[oldIdx].classList.remove('active');
				this.buttons[oldIdx].setAttribute('aria-selected', 'false');
				this.buttons[oldIdx].setAttribute('tabindex', '-1');
				this.buttons[newIdx].classList.add('active');
				this.buttons[newIdx].setAttribute('aria-selected', 'true');
				this.buttons[newIdx].setAttribute('tabindex', '0');

				if ( this.animations_enabled && !this.tl.isActive() ) {
					this.transitionFromTo(this.panels[oldIdx], this.panels[newIdx]);
				} else {
					this.panels[oldIdx].classList.remove('active');
					this.panels[oldIdx].setAttribute('hidden', '');
					this.panels[newIdx].classList.add('active');
					this.panels[newIdx].removeAttribute('hidden');
				}

	    }
	  }
		transitionFromTo(oldPanel, newPanel) {

			this.tl
				.clear()
				.to(oldPanel, { autoAlpha: 0, duration: 0.25 })
				.set(oldPanel, { className:"-=active", onComplete: () => { oldPanel.setAttribute('hidden', ''); } })
				.set(newPanel, { className:"+=active", onComplete: () => { newPanel.removeAttribute('hidden'); } })
				.to(newPanel, { autoAlpha: 1, duration: 0.25 });

			this.tl.play();
		}
	}
	customElements.define('tabbed-content', TabbedContent);
}
